import { Clock, MapPin, MessageCircle, Navigation, Phone, Sparkles } from "lucide-react";
import {
  ADDRESS,
  FORM_URL,
  HOURS,
  MAPS_URL,
  NAV_LINKS,
  PHONE_DISPLAY,
  PHONE_TEL,
  WHATSAPP_MSG_URL,
} from "./data";
import { scrollToId, useLenis } from "./lenis-context";

export default function Footer() {
  const lenis = useLenis();

  return (
    <footer data-testid="site-footer" className="bg-sapphire-ink text-white">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.3fr_1fr_0.8fr]">
          <div>
            <img src="/logo.png" alt="swaclean Facility Services" className="h-12 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-white/70">
              Siliguri&rsquo;s 4.9★ rated deep cleaning and facility management team — residential, commercial and
              post-construction specialists.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                data-testid="footer-whatsapp-link"
                href={WHATSAPP_MSG_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full bg-whatsapp px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-whatsapp-dark"
              >
                <MessageCircle className="h-4 w-4" />
                WhatsApp
              </a>
              <a
                data-testid="footer-book-now-link"
                href={FORM_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-5 py-2.5 text-sm font-bold text-white transition-colors hover:border-white/50"
              >
                Book Now
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-white/50">Visit or call</h3>
            <address
              data-testid="footer-address-block"
              className="mt-5 flex items-start gap-3 text-sm not-italic leading-relaxed text-white/80"
            >
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-whatsapp" />
              {ADDRESS}
            </address>
            <a
              data-testid="footer-phone-link"
              href={PHONE_TEL}
              className="mt-4 flex items-center gap-3 text-sm font-semibold text-white/80 transition-colors hover:text-white"
            >
              <Phone className="h-4 w-4 shrink-0 text-whatsapp" />
              {PHONE_DISPLAY}
            </a>
            <p data-testid="footer-hours" className="mt-4 flex items-center gap-3 text-sm text-white/80">
              <Clock className="h-4 w-4 shrink-0 text-whatsapp" />
              {HOURS}
            </p>
            <a
              data-testid="footer-directions-link"
              href={MAPS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-whatsapp transition-colors hover:text-white"
            >
              <Navigation className="h-4 w-4" />
              Open in Google Maps
            </a>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.25em] text-white/50">Explore</h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-nav-${l.id}`}
                    onClick={() => scrollToId(lenis, l.id)}
                    className="text-sm font-medium text-white/70 transition-colors hover:text-white"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-xs text-white/50">
            © 2026 swaclean Facility Services · Bankim Nagar, Siliguri, West Bengal
          </p>
          <p className="flex items-center gap-1.5 text-xs font-semibold text-white/60">
            <Sparkles className="h-3.5 w-3.5 text-whatsapp" />
            Spotless. On time. Every time.
          </p>
        </div>
      </div>
    </footer>
  );
}
